import {
  ICampaignDTO,
  ICampaignFiltersDto,
  ICampaignListDTO,
  ICampaignSaveResponseDTO,
  ICampaignDetailsDTO,
  ITackierRequestDTO,
  ITackierDTO,
  ITackierSaveResultDTO,
  IAggregateReportDTO,
} from "../interfaces/dto/campaign.dto";
import { get, post, patch } from "./api";
import { APIUrl } from "../config/api-url.config";
import { CampaignStatus } from "../enum/campaign";
import { IErrorDto } from "../interfaces/dto/error.dto";
import { IDateRange } from "../interfaces/campaign";

export const getCampaigns = (filters: ICampaignFiltersDto, token: string) =>
  get<ICampaignFiltersDto, ICampaignListDTO>(
    APIUrl.allCampaigns,
    filters,
    token,
  );

export const saveCampaign = (
  payload: ICampaignDTO,
  token: string,
  userId: string,
  files?: Array<File>,
) =>
  post<ICampaignDTO, ICampaignSaveResponseDTO>(
    APIUrl.campaigns(userId),
    payload,
    undefined,
    token,
    files,
  );

export const getCampaignDetails = (
  userId: string,
  campaignId: string,
  token: string,
) =>
  get<undefined, ICampaignDetailsDTO>(
    APIUrl.campaigns(userId, campaignId),
    undefined,
    token,
  );

export const updateCampaignDetails = (
  userId: string,
  campaignId: string,
  payload: ICampaignDTO,
  token: string,
  files?: Array<File>,
) =>
  patch<ICampaignDTO, ICampaignSaveResponseDTO>(
    APIUrl.campaigns(userId, campaignId),
    payload,
    undefined,
    token,
    files,
  );

interface IUpdateCampaignStatus extends IErrorDto {}

export const updateCampaignStatus = (
  campaignId: string,
  userId: string,
  status: CampaignStatus,
  token: string,
) =>
  get<undefined, IUpdateCampaignStatus>(
    APIUrl.campaignsStatus(userId, campaignId, status),
    undefined,
    token,
  );

export const getTrackier = (userId: string, campaignId: string, token: string) =>
  get<undefined, ITackierDTO>(
    APIUrl.trackier(userId, campaignId),
    undefined,
    token,
  );

export const saveTrackier = (userId: string, campaignId: string, trackierIds: Array<string>, token: string) =>
  post<ITackierRequestDTO, ITackierSaveResultDTO>(
    APIUrl.trackier(userId, campaignId),
    { trackierIds },
    undefined,
    token,
  );

export const getAggregateReport = (userId: string, token: string, dateRange: IDateRange) =>
  get<IDateRange, IAggregateReportDTO>(
    APIUrl.aggregateReport(userId),
    dateRange,
    token,
  );
